// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ImageRightsView_Wrapper__1LOme","Image":"ImageRightsView_Image__18Q9d","Text":"ImageRightsView_Text__3SnL7"};